import { parseApiResponse } from '@/shared/utils/apiResponse';
import { apiGet, apiPatch } from '@/shared/utils/requestBuilder';

import type { PreferenciasUi } from '../types';

export const preferenciasUiService = {
  async carregar(): Promise<PreferenciasUi> {
    const response = await apiGet('/me/preferencias-ui');
    const data = await parseApiResponse<PreferenciasUi | null>(response);
    return data ?? {};
  },

  async atualizar(patch: PreferenciasUi): Promise<void> {
    const response = await apiPatch('/me/preferencias-ui', patch);
    await parseApiResponse<PreferenciasUi | undefined>(response, { allowNoContent: true });
  },
};
